export enum WorkOrderStatus {
  NotStarted = 'NotStarted',
  Ready = 'Ready',
  InProduction = 'InProduction',
  OnHold = 'OnHold',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export const getWorkOrderStatus = (value: string): WorkOrderStatus => {
  if (Object.values(WorkOrderStatus).includes(value as WorkOrderStatus)) {
    return value as WorkOrderStatus
  }
  return WorkOrderStatus.NotStarted
}

export const getWorkOrderStatusLabel = (status: WorkOrderStatus): string => {
  const labels: Record<WorkOrderStatus, string> = {
    [WorkOrderStatus.NotStarted]: 'Not Started',
    [WorkOrderStatus.Ready]: 'Ready',
    [WorkOrderStatus.InProduction]: 'In Production',
    [WorkOrderStatus.OnHold]: 'On Hold',
    [WorkOrderStatus.Completed]: 'Completed',
    [WorkOrderStatus.Cancelled]: 'Cancelled',
  }
  return labels[status] ?? status
}

export enum WorkOrderType {
  GreenTagging = 'green-tagging',
  Escalation = 'escalation',
  Update = 'update',
  LocateEquipment = 'locate-equipment',
  Calibration = 'calibration',
}

export const getWorkOrderType = (value: string): WorkOrderType => {
  if (Object.values(WorkOrderType).includes(value as WorkOrderType)) {
    return value as WorkOrderType
  }
  return WorkOrderType.GreenTagging
}

export const getWorkOrderTypeLabel = (type: WorkOrderType): string => {
  const labels: Record<WorkOrderType, string> = {
    [WorkOrderType.GreenTagging]: 'Green Tagging',
    [WorkOrderType.Escalation]: 'Escalation',
    [WorkOrderType.Update]: 'Update',
    [WorkOrderType.LocateEquipment]: 'Locate Equipment',
    [WorkOrderType.Calibration]: 'Calibration',
  }
  return labels[type] ?? type
}
